import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadWorkshops } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';

class Workshops extends Component { 

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}
	
	reloadData() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleDelete(id) {
		const { deleteWorkshop } = this.props;
		deleteWorkshop(id, () => this.reloadData());
	}

	render() {
		const { isReadonly, pagination, data, t } = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} loading={this.props.pagination.loading} />
				<List
					isReadonly={isReadonly}
					onFetchData={this.handleListEvent}
					onDelete={this.handleDelete}
					data={data}
					t={t}
					{...pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { workshops },
		auth: { currentUser }
	} = state;

	const workshopPagination = pagination.workshops.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: workshopPagination.ids.map(id => workshops[id]),
		pagination: workshopPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Workshops')
	};
};

const mapDispatchToProps = {
	loadEntities: loadWorkshops,
	initializeFilter: (data, fields) => initialize('workshopFilter', data, fields)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Workshops));